import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-reject-dialog",
  templateUrl: "./reject-dialog.component.html",
  styleUrls: ["./reject-dialog.component.scss"],
})
export class RejectDialogComponent implements OnInit {
  form: FormGroup;

  title: string;
  message: string;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<RejectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.title = data.title;
    this.message = data.message;
  }

  ngOnInit() {
    this.form = this.fb.group({
      justification: ['', [Validators.required, Validators.maxLength(1000), Validators.minLength(4)]],
    });
  }

  confirmRejection(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
